import {Heading, Link} from '@primer/react-brand/esm'

import type {FooterLinkSection} from '../../marketing-footer.types'

import styles from './LinkColumn.module.css'

type Props = {
  section: FooterLinkSection
}

export function LinkColumn({section}: Props) {
  const {id, title, context, links} = section

  return (
    <nav className={styles.column} aria-labelledby={id}>
      <Heading as="h3" size="6" font="monospace" className={styles.heading} id={id}>
        {title}
      </Heading>

      <ul className={styles.list}>
        {links.map(link => (
          <li key={`${link.href}-${link.label}`} className={styles.item}>
            <Link
              size="small"
              arrowDirection="none"
              href={link.href}
              data-analytics-event={JSON.stringify({
                location: 'footer',
                tag: 'link',
                action: link.analyticsAction ?? '',
                context,
              })}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
